import { render } from "./TreeNode.vue?vue&type=template&id=01538e3e&scoped=true&ts=true"
import script from "./TreeNode.vue?vue&type=script&lang=ts"
export * from "./TreeNode.vue?vue&type=script&lang=ts"

import "./tree-view.scss?vue&type=style&index=0&id=01538e3e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01538e3e"]])

export default __exports__